import React from "react";
import HomeAccordion from "./../../../components/accordions/HomeAccordion";
import AddIndividualPatientDataSection from "./sections/AddIndividualPatientDataSection";
import UploadMultiplePatientsSection from "./sections/UploadMultiplePatientsSection";
import StaticIndividualPatientSection from "./sections/StaticIndividualPatientSection";
import StaticUploadMultipleSection from "./sections/StaticUploadMultipleSection";
import { useHomeTab } from "./homeTabContext";
import { prostateCancerFieldMapping, mentalHealthFieldMapping, PROSTATE_DECIMAL_FIELDS } from "../../../utils/constants";
import { addProstateCancerRecords, addBulkProstateCancerRecords } from "../../../utils/services";

const Home = () => {
  const { activeTab } = useHomeTab();

  const accordions =
    activeTab === 1
      ? [
          { title: "Create Individual Patient Information", component: <StaticIndividualPatientSection fieldMapping={prostateCancerFieldMapping} decimalFields={PROSTATE_DECIMAL_FIELDS} submitRecordsFn={addProstateCancerRecords} /> },
          { title: "Upload Multiple Patient Information", component: <StaticUploadMultipleSection fieldMapping={prostateCancerFieldMapping} submitBulkFn={addBulkProstateCancerRecords} acceptTypes=".csv,.xlsx,.xls" /> },
        ]
      : activeTab === 2
      ? [
          { title: "Create Individual Patient Information", component: <StaticIndividualPatientSection fieldMapping={mentalHealthFieldMapping} /> },
          { title: "Upload Multiple Patient Information", component: <StaticUploadMultipleSection fieldMapping={mentalHealthFieldMapping} /> },
        ]
      : [
          { title: "Create Individual Patient Information", component: <AddIndividualPatientDataSection /> },
          { title: "Upload Multiple Patient Information", component: <UploadMultiplePatientsSection /> },
        ];

  return (
    <>
      {accordions.map((data, index) => (
        <HomeAccordion
          render={data.component}
          title={data.title}
          index={index}
          key={`${activeTab}-${index}`}
        />
      ))}
    </>
  );
};

export default Home;
